document.addEventListener('DOMContentLoaded', function(){
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
if (links[i].hostname !== window.location.hostname) {
links[i].target = '_blank';
links[i].rel = 'noreferrer noopener';
}
}
});


// category page BUY IT NOW button JS code
  document.querySelectorAll('.product-quick-buy__container .buy-now-btn').forEach((button) => {
    button.addEventListener('click', function () {
      // Get the form ID from the button's data-form-id attribute
      const formId = this.getAttribute('data-form-id');

      // Get the corresponding form using the form ID
      const form = document.querySelector(`#${formId}`);

      // Ensure the form exists
      if (!form) {
        return;
      }

      // Create the form data to submit to Shopify's AJAX cart API
      const formData = new FormData(form);

      // Use Shopify's AJAX API to add the product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          // Redirect to the checkout page once the item is added to the cart
          window.location.href = '/checkout';
        })
        .catch((error) => {
          console.error('Error adding product to cart:', error);
        });
    });
  });